import { CurrencyValueForm } from 'models/apps'
import { localeStringToFloat, formatNumberWithSep } from 'utils/format-number'

export const forbiddenAmounts = ['0', '0,', '0.0', '0.00', '0,0', '0,00']

export const validateCurrencyAmountOnInput = (value: string, maxIntegerPartLength: number): CurrencyValueForm => {
  if (!value) {
    return {
      currentValue: '',
      currentValueFormatted: '',
      isValueCorrect: false,
    }
  }

  const raw = value.replace(',', '.')
  const hasTrailingDot = raw.endsWith('.')
  const separatorIndex = raw.indexOf('.')

  let intPartRaw: string
  let decimalPartRaw: string | undefined

  if (separatorIndex === -1) {
    intPartRaw = raw
    decimalPartRaw = undefined
  } else {
    intPartRaw = raw.substring(0, separatorIndex)
    const rest = raw.substring(separatorIndex + 1)
    decimalPartRaw = rest.replace(/\./g, '')
  }

  // integer part can be empty, but if it exists, it should be limited by config
  const intPartClean = intPartRaw.replace(/\D/g, '')
  let intPart = intPartClean.replace(/^0+(?=\d)/, '').slice(0, maxIntegerPartLength)
  if (intPart === '') intPart = '0'

  // decimal part can be empty, but if it exists, it should be limited to 2 digits
  const decimalPart = decimalPartRaw?.replace(/\D/g, '').slice(0, 2) ?? ''

  let currentValue: string
  if (hasTrailingDot && decimalPart === '') {
    currentValue = `${intPart}.`
  } else if (decimalPart) {
    currentValue = `${intPart}.${decimalPart}`
  } else {
    currentValue = intPart
  }

  const currentValueFormatted = currentValue.replace('.', ',')
  const isValueCorrect = !forbiddenAmounts.includes(currentValueFormatted)

  return {
    currentValue,
    currentValueFormatted,
    isValueCorrect,
  }
}

export const formatCurrencyAmount = (value: string): CurrencyValueForm => {
  if (!value) {
    return {
      currentValue: '',
      currentValueFormatted: '',
      isValueCorrect: false,
    }
  }

  return {
    currentValue: localeStringToFloat(value),
    currentValueFormatted: formatNumberWithSep(value.replace(',', '.')),
    isValueCorrect: !forbiddenAmounts.includes(formatNumberWithSep(value)),
  }
}
